import { defineAttrs as e } from "../../utils/typed-attrs.js";
var t = {
	inline: !0,
	attrs: e({
		attributePath: { default: "" },
		fallback: { default: "" }
	}),
	group: "inline",
	selectable: !0,
	parseDOM: [{
		tag: "span.embercom-prosemirror-composer-template",
		getAttrs(e) {
			return {
				attributePath: e.getAttribute("data-template-identifier"),
				fallback: e.getAttribute("data-template-fallback")
			};
		}
	}],
	toDOM(e) {
		let t = e.attrs, n = t.attributePath, r = t.fallback, i = e.type.spec.infoResolver, a = i?.humanReadable(n), o = ["embercom-prosemirror-composer-template", "intercom-interblocks-template"];
		return i && !i.isValid(n) && o.push("invalid"), i?.requiresFallback(n, r) && o.push("requires-fallback"), [
			"span",
			{
				class: o.join(" "),
				"data-template-identifier": n,
				"data-template-fallback": r
			},
			a
		];
	}
};
//#endregion
export { t as templateSpec };
